"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ReferenceResolverAllType = _interopRequireDefault(require("./ReferenceResolverAllType"));

var _ReferenceResolverSearchType = _interopRequireDefault(require("./ReferenceResolverSearchType"));

var _default = _propTypes.default.oneOfType([_ReferenceResolverAllType.default.isRequired, _ReferenceResolverSearchType.default.isRequired]);

exports.default = _default;
module.exports = exports.default;